/* eslint-disable prettier/prettier */
/* eslint-disable no-console */

import request from '@/utils/request'
import qs from 'qs'

//========= 检查
//甲方单位
export const queryPartyaNames = () => {
  return request({
    url: '/inspect/queryPartyaNames',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: {}
  })
}
// 查看设备总数
export const getInpectDeviceCount = (postData) => {
  return request({
    url: '/inspect/getInpectDeviceCount',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}

// 查看设备平均分
export const getDeviceAveScore = (postData) => {
  return request({
    url: '/inspect/getDeviceAveScore',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 根据类型统计设备数量
export const queryDeviceByType = (postData) => {
  return request({
    url: '/inspect/queryDeviceByType',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 根据隐患查看不同等级的问题数量
export const queryScoreByLevel = (postData) => {
  return request({
    url: '/inspect/queryScoreByLevel',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 根据不同设备隐患查看不同等级的问题数量
export const queryScoreByLevel_s = (postData) => {
  return request({
    url: '/inspect/queryScoreByLevelThird',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 多维度统计得分
export const queryScore = (postData) => {
  return request({
    url: '/inspect/queryScore',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 根据月份统计数量
export const queryDeviceByMonth = (postData) => {
  return request({
    url: '/inspect/queryDeviceByMonth',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}

//设备扣分统计
export const inspectQuestionInfo = (postData) => {
  return request({
    url: '/inspect/inspectQuestionInfo',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
//检查台账
export const listDeviceQuestion = (postData) => {
  return request({
    url: '/account/listDeviceQuestion',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
//检查台账导出下载
export const deviceQuestionExport = (postData) => {
  return request({
    url: '/account/deviceQuestionExport',
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded;'
    },
    data: qs.stringify(postData),
    responseType: 'blob'
  })
}